/**
 * Safe Storage Access (Million-User Grade)
 * Prevents iOS Safari Private Mode and strict ITP Security/Quota errors 
 * from crashing the React tree synchronously (White Screens).
 */
export const safeSessionStorage = {
  getItem: (key: string): string | null => {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  },
  setItem: (key: string, value: string): void => {
    try { sessionStorage.setItem(key, value); } catch (e) { console.warn('sessionStorage restricted'); }
  },
  removeItem: (key: string): void => {
    try { sessionStorage.removeItem(key); } catch (e) { console.warn('sessionStorage restricted'); }
  }
};

export const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  },
  setItem: (key: string, value: string): void => {
    try { localStorage.setItem(key, value); } catch (e) { console.warn('localStorage restricted'); }
  },
  removeItem: (key: string): void => {
    try { localStorage.removeItem(key); } catch (e) { console.warn('localStorage restricted'); }
  }
};
